import { v4 as uuidv4 } from 'uuid';
import { inject, Injectable } from '@angular/core';
import { translate } from '@jsverse/transloco';
import { ID_PREFIX_SUFIX } from '../..';

@Injectable({ providedIn: 'root' })
export class UniqueIdService {
  private IdPS = inject(ID_PREFIX_SUFIX);
  // private translate = inject(translate);
  public generateUniqueId(deviceType: string, prefix: string = this.IdPS.prefix): string {
    // Ensure the prefix is provided
    if (!prefix) {
      throw new Error('Prefix is required to generate the unique ID.');
    }

    // Generate a globally unique identifier (UUID)
    const uuid = uuidv4();

    // Extract the first 8 digits from the UUID (removing non-numeric characters)
    const uniqueNumbers = uuid.replace(/\D/g, '').slice(0, 8);

    // Ensure the device type is valid
    if (!this.IdPS.sufix?.find((x) => x.sign)) {
      throw new Error(
        `Invalid device type. Use ${this.IdPS.sufix
          .map((x) => `${x.sign} for ${translate(`data.modal.${x.name}`)}`)
          .join(', ')}.`,
      );
    }

    // Construct the final ID using the provided prefix
    return `${prefix}${uniqueNumbers}${deviceType}`;
  }
}
